import escapeRegExp from 'lodash/escapeRegExp';
export function stringContainsCaseInsensitive(contain, searchIn) {
    return new RegExp(`${escapeRegExp(contain)}`, 'i').test(searchIn);
}
